import { render, staticRenderFns } from "./PartnerOpportunity.vue?vue&type=template&id=507b8c99&scoped=true"
import script from "./PartnerOpportunity.vue?vue&type=script&lang=js"
export * from "./PartnerOpportunity.vue?vue&type=script&lang=js"
import style0 from "./PartnerOpportunity.vue?vue&type=style&index=0&id=507b8c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b8c99",
  null
  
)

export default component.exports